import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Attachments from "../../modals/Attachments";

const answerLabel = (item) => {
  if (item?.answer) return item.answer;
  const match = item?.options?.find((option) => option.uuid === item?.responseId);
  return match?.option || "N/A";
};

const AnswerTable = ({ title, answers, emptyText }) => {
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachment, setAttachment] = useState([]);
  const rows = Array.isArray(answers) ? answers : [];

  return (
    <section style={{ marginTop: 28 }}>
      <h2 className="sites-v2__title" style={{ fontSize: 20 }}>{title}</h2>
      {rows.length === 0 ? (
        <p>{emptyText}</p>
      ) : (
        <div className="table-responsive workflowtb mt-3">
          <table className="table align-middle table-nowrap mb-0">
            <thead>
              <tr>
                <th className="text-center">S.No.</th>
                <th>Question</th>
                <th className="text-center">Response</th>
                <th className="text-center">Selected List Option</th>
                <th className="text-center">Attachments</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((item, index) => {
                const label = answerLabel(item);
                const tone = label === "Yes" ? "good" : label === "No" ? "bad" : "other text-muted";
                return (
                  <tr key={item.uniqueKey || item.questionId || index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="ques-comment">
                        <span>{item.question || item.title || ""}</span>
                        {item.comment ? (
                          <span className="comment">
                            {" "}
                            <span> Comment : </span>
                            {item.comment}
                          </span>
                        ) : null}
                      </div>
                    </td>
                    <td className="text-center">
                      <span className={tone}>{label}</span>
                    </td>
                    <td className="text-center">{item.selectedListOptionLabel || "N/A"}</td>
                    <td className="text-center">
                      {item.attachments?.length > 0 ? (
                        <button
                          type="button"
                          className="plain-btn"
                          onClick={() => {
                            setAttachment(item.attachments);
                            setShowAttachments(true);
                          }}
                        >
                          View
                        </button>
                      ) : (
                        "NA"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <Attachments showAttachments={showAttachments} setShowAttachments={setShowAttachments} attachment={attachment} />
    </section>
  );
};

const FreezerSessionDetail = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [row, setRow] = useState(null);

  useEffect(() => {
    axios
      .get(`${configData.config.API_URL}/api/freezer-frost/session/${sessionId}`, {
        headers: { Authorization: `Bearer ${userData.token}` },
      })
      .then((response) => setRow(response.data.data))
      .catch((error) => console.log(error));
  }, [sessionId, configData?.config?.API_URL, userData?.token]);

  if (!row) return <div className="sites-v2">Loading session...</div>;

  const exitEmpty = row.status === "entry_open" ? "Exit pending" : row.exitQrMissed ? "Exit missed" : "No exit answers";

  return (
    <div className="sites-v2">
      <button type="button" className="sites-v2__reset-btn" onClick={() => navigate(`/ff/info/${row.parentUuid}`)}>
        Back
      </button>
      <h1 className="sites-v2__title">{row.freezerName}</h1>
      <p className="sites-v2__subtitle">
        {row.userUuid} · {row.status}
        {row.exitQrMissed ? " · missed exit" : ""} · floor {row.floor || "—"}
      </p>
      <p>
        Entry: {row.entryTime ? new Date(row.entryTime).toLocaleString() : "—"} · Exit:{" "}
        {row.exitTime ? new Date(row.exitTime).toLocaleString() : "—"} · Duration:{" "}
        {row.durationSeconds != null ? `${Math.round(row.durationSeconds / 60)} min` : "—"}
      </p>
      <AnswerTable title="Entry Questionnaire Response" answers={row.entryData} emptyText="No entry answers" />
      <AnswerTable title="Exit Questionnaire Response" answers={row.exitData} emptyText={exitEmpty} />
    </div>
  );
};

export default FreezerSessionDetail;
